export default class PressReleases {
	constructor(config) {
		this.el = config.el || document.querySelectorAll(".press-releases");
		this.filters = this.el.querySelector(".press-releases__filters");

		this.items = [...this.el.querySelectorAll(".press-releases__item")];
		this.inputs = null;
		this.years = [
			...new Set(
				this.items.map(item => {
					return item.dataset.year;
				})
			)
		].reverse(); // get unique years
		this.activeFilters = [];

		this.init();
	}

	init() {
		this.renderButtons();
		this.attachEvents();
		this.checkQueryParams();
	}
	attachEvents() {
		const self = this;
		this.inputs.forEach(input => {
			input.addEventListener("change", event => {
				const value = event.target.value;
				const indexOfValue = self.activeFilters.indexOf(value);
				indexOfValue > -1
					? self.activeFilters.splice(indexOfValue, 1)
					: self.activeFilters.push(value);
				self.updateView();
				utilities.setQueryStringParameter(
					"filters",
					this.activeFilters
				);
			});
		});
	}
	renderButtons() {
		let filtersString = '<ul class="ul--nostyling button-list grid">';
		this.years = this.years.reverse();
		this.years.forEach(year => {
			let buttonMarkup = `<li class="col-auto"><label class="button-switch"><input class="button-switch-input" type="checkbox" value="${year}"><span class="button-switch__button">${year}</span></label></li>`;
			filtersString += buttonMarkup;
		});
		filtersString += "</ul>";
		this.filters.innerHTML = filtersString;
		this.inputs = this.filters.querySelectorAll(".button-switch-input");
	}
	updateView() {
		if (this.activeFilters.length > 0) {
			this.items.forEach(item => {
				if (this.activeFilters.indexOf(item.dataset.year) > -1) {
					item.classList.remove("press-releases__item--hide");
				} else {
					item.classList.add("press-releases__item--hide");
				}
			});
		} else {
			this.showAll();
		}
	}
	showAll() {
		this.items.forEach(item => {
			item.classList.remove("press-releases__item--hide");
		});
	}
	checkQueryParams() {
		const urlParams = new URLSearchParams(window.location.search);
		const filters = urlParams.get("filters");
		if (filters) {
			this.activeFilters = filters.split(",");
		}
		this.updateView();
		this.setInputsValue();
	}
	setInputsValue() {
		this.activeFilters.forEach(filter => {
			this.inputs.forEach(input => {
				//console.log(input.value);
				if (input.value == filter) {
					input.checked = true;
				}
			});
		});
	}
}
